import './MemberStream.scss';
import { WebRTCAdaptor } from '../../../js/webrtc_adaptor';
import { env } from '../../../services/CommonFunction';

const PlayStream = (props,startStream = () => null) => {
    const userId = props.user_activity_session_id;
    var pc_config = null;

    var sdpConstraints = {
        OfferToReceiveAudio: true,
        OfferToReceiveVideo: true
    };

    var mediaConstraints = {
        video: true,
        audio: false
    };
    // var WebRTCAdaptor = require(adapter);
    console.log(userId,props.user_id);

    let webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: env('AntMediaUrl'),
        mediaConstraints: mediaConstraints,
        peerconnection_config: pc_config,
        sdp_constraints: sdpConstraints,
        remoteVideoId: props.user_id+'_video',
        isPlayMode: true,
        callback: function (info) {
            if (info === "initialized") {
                console.log('initialized');
                webRTCAdaptor.play(userId);
                //called by JavaScript SDK when WebSocket is connected. 
            } else if (info === "joinedTheRoom") {
                console.log('joinedTheRoom');
                //called when this client is joined the room
                //obj contains streamId field which this client can use to publish to the room.
                //obj contains also the active streams in the room so that you can play them directly.
                //In order to get the streams in the room periodically call `getRoominfo`
            } else if (info === "play_started") {
                //play_started
                console.log("play started");
                setTimeout(() => {
                    startStream();
                }, 1000);
            } else if (info === "newStreamAvailable") {
                console.log('newStreamAvailable');
                //called when client is ready to play WebRTC stream.
            } else if (info === "publish_started") {
                console.log('publish_started');
                //called when stream publishing is started for this client		
            } else if (info === "publish_finished") {
                console.log('publish_finished');
                //called when stream publishing has finished for this client
            } else if (info === "leavedFromRoom") {
                console.log('leavedFromRoom');
                //called when this client is leaved from the room  	
            } else if (info === "closed") {
                console.log('closed');
                //called when websocket connection is closed	
            } else if (info === "play_finished") {
                console.log('play_finished');
                //called when a stream has finished playing	
            } else if (info === "streamInformation") {
                console.log('streamInformation');
                //called when a stream information is received from the server. 
                //This is the response of `getStreamInfo` method		
            } else if (info === "roomInformation") {
                console.log('roomInformation');
                //Called by response of `getRoomInfo` when a room information is received from the server.
                //It contains the array of the streams in the room.
            } else if (info === "data_channel_opened") {
                console.log('data_channel_opened');
                //called when data channel is opened
            } else if (info === "data_channel_closed") {
                console.log('data_channel_closed');
                // called when data channel is closed
            } else if (info === "data_received") {
                console.log('data_received');
                //called when data is received through data channel
            }
        },
        callbackError: function (error) {
            //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
            console.log("error callback: " + error);
            // alert(error);
        }
    });
    return webRTCAdaptor;
}

export default PlayStream;